import { render } from "./OurTeamPanel.vue?vue&type=template&id=02fb95a8"
import script from "./OurTeamPanel.vue?vue&type=script&lang=js"
export * from "./OurTeamPanel.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__